var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { memo, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import CheckIcon from 'images/v5/icons/check.svg';
import EditSvg from 'images/v5/icons/edit-02.svg';
import TrashSvg from 'images/v5/icons/trash-03.svg';
import Button from 'layout/atoms/Button/Button';
import Dropdown from 'layout/atoms/Dropdown/Dropdown';
import Loader from 'layout/atoms/Loader/Loader';
import { Cell, Row } from 'layout/atoms/TableGrid';
import EmptyState from 'layout/molecules/EmptyState/EmptyState';
import Grid from 'layout/molecules/Grid/Grid';
import { openModal } from 'store/layoutSlice';
import { fetchSeasons, removeSeason, selectSeasons, selectSeasonsErrors, selectSeasonsPageInfo, selectSeasonsRefetchFlags, selectSeasonsStatus, setWorkingSeason, } from 'store/parameters/seasonsSlice';
import ParametersTable from '../shared/ParametersTable';
function Seasons() {
    const dispatch = useDispatch();
    const { t } = useTranslation(['specification', 'common']);
    const seasons = useSelector(selectSeasons);
    const pageInfo = useSelector(selectSeasonsPageInfo);
    const status = useSelector(selectSeasonsStatus);
    const errors = useSelector(selectSeasonsErrors);
    const refetchFlags = useSelector(selectSeasonsRefetchFlags);
    const [seasonBeingUpdated, setSeasonBeingUpdated] = useState(null);
    const fetchMore = () => {
        if (pageInfo.hasNextPage && status.fetch !== 'loading') {
            dispatch(fetchSeasons());
        }
    };
    useEffect(() => {
        if (status.fetch === 'idle' || refetchFlags.fetch) {
            dispatch(fetchSeasons());
        }
    }, [dispatch, status.fetch, refetchFlags.fetch]);
    const handleDelete = (seasonId) => {
        dispatch(removeSeason(seasonId));
    };
    const handleSetWorkingSeason = (seasonId) => __awaiter(this, void 0, void 0, function* () {
        setSeasonBeingUpdated(seasonId);
        try {
            yield dispatch(setWorkingSeason(seasonId));
        }
        finally {
            setSeasonBeingUpdated(null);
        }
    });
    if (status.fetch === 'loading' || status.fetch === 'idle') {
        return React.createElement(Loader, null);
    }
    if (status.fetch === 'failed') {
        return React.createElement("div", null, errors.fetch);
    }
    const hasSeasons = seasons.length > 0;
    return (React.createElement(Grid, { gap: 24 },
        React.createElement("div", { style: { display: 'flex', alignItems: 'center', justifyContent: 'flex-end' } },
            React.createElement(Button, { color: "primary", onClick: () => dispatch(openModal({ name: 'seasonCreator' })) }, t('add_season'))),
        hasSeasons ? (React.createElement(ParametersTable, { columns: [
                ['320px', '1fr'],
                ['72px', 'auto'],
            ], headers: [{ content: t('common:name') }, { content: null }], dataLength: seasons.length, hasMore: pageInfo.hasNextPage, fetchMore: fetchMore }, seasons.map((season) => (React.createElement(Row, { key: season.id },
            React.createElement(Cell, null,
                React.createElement("span", null, season.name),
                season.workingSeason && (React.createElement("span", { style: {
                        marginLeft: 8,
                        padding: '2px 8px',
                        borderRadius: 999,
                        backgroundColor: '#E6F4FF',
                        color: '#1C7ED6',
                        fontSize: 12,
                        fontWeight: 500,
                        display: 'inline-block',
                    } }, t('specification:working_season_current')))),
            React.createElement(Cell, null,
                React.createElement(Dropdown, null,
                    React.createElement(Button, { align: "left", theme: "ghost", leftIcon: React.createElement(CheckIcon, null), loading: seasonBeingUpdated === season.id && status.setWorking === 'loading', disabled: season.workingSeason ||
                            (status.setWorking === 'loading' && seasonBeingUpdated !== season.id), onClick: () => handleSetWorkingSeason(season.id) }, season.workingSeason
                        ? t('specification:working_season_current')
                        : t('specification:set_working_season')),
                    (season === null || season === void 0 ? void 0 : season.canNameBeUpdated) && (React.createElement(Button, { align: "left", theme: "ghost", leftIcon: React.createElement(EditSvg, null), onClick: () => dispatch(openModal({ name: 'seasonEditor', id: season.id })) }, t('common:edit'))),
                    (season === null || season === void 0 ? void 0 : season.canBeRemoved) && (React.createElement(Button, { align: "left", theme: "ghost", color: "danger", leftIcon: React.createElement(TrashSvg, null), onClick: () => handleDelete(season.id) }, t('common:delete')))))))))) : (React.createElement(EmptyState, null))));
}
export default memo(Seasons);
